import { render, staticRenderFns } from "./aboutComponent.vue?vue&type=template&id=f3a889bc&scoped=true&"
import script from "./aboutComponent.vue?vue&type=script&lang=js&"
export * from "./aboutComponent.vue?vue&type=script&lang=js&"
import style0 from "./aboutComponent.vue?vue&type=style&index=0&id=f3a889bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a889bc",
  null
  
)

export default component.exports